
import axios from "axios";
import { API_ROOT } from "../../constants/constants";
import { getAccessToken } from "../../utils/okta-config";
async function getLocations() {
    const options = {
        headers: {
            'Access-Control-Allow-Origin': API_ROOT,
            Authorization: `Bearer ${getAccessToken()}`
        }
    };
    const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/location/getAllLocations`,  options
    );
    const locations = response.data;
    return locations;
}
export default getLocations;